@if (isOpen) {
  <div
    class="fixed inset-0 z-40 bg-black/40 transition-opacity duration-300"
    (click)="close()"
  ></div>
}

<div
  [ngClass]="'fixed top-0 right-0 z-50 h-full bg-white shadow-lg transition-transform duration-300 ' + width"
  [style.transform]="panelTransform"
  role="dialog"
  aria-modal="true"
  >
  <button
    type="button"
    class="absolute -left-6 top-24 z-[60] flex h-10 w-6 items-center justify-center rounded-l-md rounded-r-none bg-blue600 text-white shadow"
    [attr.aria-label]="isOpen ? 'Close panel' : 'Open panel'"
    (click)="isOpen ? close() : open()"
    >
    <span>{{ isOpen ? '❯' : '❮' }}</span>
  </button>

  <div class="flex items-center justify-between border-b border-slate200 p-4">
    <h2 class="text-lg font-semibold ml-2">Panel</h2>
    <button
      (click)="close()"
      aria-label="Close panel"
      class="text-slate600 hover:text-slate900 focus:outline-none"
      >
      ✕
    </button>
  </div>

  <div class="p-4 overflow-y-auto h-[calc(100%-56px)]">
    <ng-content></ng-content>
  </div>
</div>
